import { WifiOff } from 'lucide-react';
import { useOffline } from '../hooks/useOffline';

export const OfflineBanner = () => {
  const isOffline = useOffline();

  if (!isOffline) return null;

  return (
    <div className="offline-banner" data-testid="offline-banner">
      <div className="flex items-center justify-center gap-2">
        <WifiOff size={16} />
        <span>Mode hors-ligne</span>
      </div>
    </div>
  );
};

export default OfflineBanner;
